<template>
  <img alt="HolidaySale" :src="banner" />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import desktopDE from '@/assets/holiday-event/desktop/DE.jpg'
import desktopEN from '@/assets/holiday-event/desktop/EN.jpg'
import desktopES from '@/assets/holiday-event/desktop/ES.jpg'
import desktopFR from '@/assets/holiday-event/desktop/FR.jpg'
import desktopJP from '@/assets/holiday-event/desktop/JP.jpg'
import desktopKR from '@/assets/holiday-event/desktop/KR.jpg'
import desktopTH from '@/assets/holiday-event/desktop/TH.jpg'
import desktopTW from '@/assets/holiday-event/desktop/TW.jpg'
import mobileDE from '@/assets/holiday-event/mobile/DE.jpg'
import mobileEN from '@/assets/holiday-event/mobile/EN.jpg'
import mobileES from '@/assets/holiday-event/mobile/ES.jpg'
import mobileFR from '@/assets/holiday-event/mobile/FR.jpg'
import mobileJP from '@/assets/holiday-event/mobile/JP.jpg'
import mobileKR from '@/assets/holiday-event/mobile/KR.jpg'
import mobileTH from '@/assets/holiday-event/mobile/TH.jpg'
import mobileTW from '@/assets/holiday-event/mobile/TW.jpg'
import { Locale } from '@/graphql/creator-platform/generated'
import { storeConfig } from '@/locale'
import { useLayoutStore } from '@/store/layoutStore'

const { isMobile } = storeToRefs(useLayoutStore())

const banner = computed(() => {
  switch (storeConfig.locale) {
    case Locale.Asia: {
      return isMobile.value ? mobileEN : desktopEN
    }
    case Locale.De: {
      return isMobile.value ? mobileDE : desktopDE
    }
    case Locale.Es: {
      return isMobile.value ? mobileES : desktopES
    }
    case Locale.Eu: {
      return isMobile.value ? mobileEN : desktopEN
    }
    case Locale.Fr: {
      return isMobile.value ? mobileFR : desktopFR
    }
    case Locale.Io: {
      return isMobile.value ? mobileEN : desktopEN
    }
    case Locale.Jp: {
      return isMobile.value ? mobileJP : desktopJP
    }
    case Locale.Kr: {
      return isMobile.value ? mobileKR : desktopKR
    }
    case Locale.Th: {
      return isMobile.value ? mobileTH : desktopTH
    }
    case Locale.Tw: {
      return isMobile.value ? mobileTW : desktopTW
    }
    case Locale.Uk: {
      return isMobile.value ? mobileEN : desktopEN
    }
    default: {
      return isMobile.value ? mobileEN : desktopEN
    }
  }
})
</script>
